export default function only(...props) {
  return (route) =>
    props.reduce((obj, prop) => ({ ...obj, [prop]: route.params[prop] }), {});
}
